import { useSelector } from "react-redux";
import { Grid, Typography } from "@mui/material";
import { getThemeCompareSelectedValue } from "../../../reducer/patientCompareSlice";
import { useEffect, useState } from "react";
import { getAreaLevel } from "../../../reducer/areaLevelSlice";

const label = {
    province: [1, 11, 51, 151, 400],
    amphur: [1, 6, 21, 51, 100],
    tambon: [1, 2, 6, 11, 20]
}
const size = [6, 12, 18, 24, 30];
function PatientLegend(props) {
    const [labelSelected, setLabelSelected] = useState([]);
    const areaLevel = useSelector(getAreaLevel);
    // const themeCompare = useSelector(getThemeCompareSelectedValue);
    // const populationValue = useSelector(getPopulationRate);

    useEffect(() => {
        // console.log(areaLevel);
        const conditions = label[areaLevel];
        // console.log(conditions);
        let tmp = [];
        for (let index = 0; index < conditions.length; index++) {
            const patient = conditions[index];
            // let patient = parseInt(element);
            let label = "";
            if (index + 1 < conditions.length) {
                if ((conditions[index + 1] - 1) === patient) {
                    label = patient;
                } else {
                    label = patient + " - " + (conditions[index + 1] - 1);
                }
            } else {
                label = "≥ " + patient;
            }
            tmp.push(label);
        }
        setLabelSelected(tmp);
    }, [areaLevel])

    return (
        <>
            <div style={{
                position: 'relative'
            }}>
                <Typography sx={{ 
                    fontSize: 12, 
                    textAlign: 'left',
                    fontWeight: '400',
                }}>
                    จำนวนผู้ป่วย (ราย)
                </Typography>
                <Grid container spacing={0}>
                {
                    size.map((data, index) => {
                        // console.log(data);
                        return (
                            <Grid 
                                key={index} 
                                item 
                                xs={(12/size.length)}
                                sx={{
                                    alignItems: 'center',
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}
                            >
                                <div style={{
                                    height: `${data}px`,
                                    width: `${data}px`,
                                    backgroundColor: '#D92405',
                                    borderRadius: '50px',
                                    borderStyle: 'solid',
                                    borderWidth: '1px',
                                    borderColor: 'black',
                                }}></div>
                            </Grid>
                        )
                    })
                }
                {
                    labelSelected.map((data, index) => {
                        return (
                            <Grid key={index} item xs={(12/labelSelected.length)}>
                                <Typography sx={{
                                    fontSize: 10,
                                    textAlign: 'center',
                                    marginTop: '5px',
                                    fontWeight: '400',
                                }}>
                                    {data}
                                </Typography>
                            </Grid>
                        )
                    })
                }
                </Grid>
            </div>
        </>
    )
}

export default PatientLegend;